const datamanagerintentions = (state = [], action) => {
    switch (action.type) {
      case 'HANDLE_DATA_INTENTIONS':
        return action.data
      default:
        return state
    }
  }
  
  export default datamanagerintentions